module.exports = __webpack_public_path__ + "static/media/Panther871_4c.ade8e28c.svg";